export const countries = {
  gp: {
    description:
      "L'isola farfalla che offre palesemente una ricca cultura creola e l'imponente vulcano Soufrière.",
    landmarks: [
      "Vulcano Soufrière",
      "Spiaggia Grande Anse",
      "Cascate del Carbet",
    ],
    gastronomy:
      "Frittelle di baccalà, pollo al colombo, torta tourment d'amour.",
  },
  mq: {
    description:
      "L'affascinante Isola dei Fiori, celebre per il Monte Pelée e il rum agricolo.",
    landmarks: ["Monte Pelée", "Giardino di Balata", "Rocca del Diamante"],
    gastronomy: "Pollo affumicato, sanguinaccio creolo, blanc-manger al cocco.",
  },
  gf: {
    description:
      "La porta dell'Europa verso lo spazio e rifugio di una biodiversità amazzonica inestimabile.",
    landmarks: [
      "Centro Spaziale Guianese",
      "Isole della Salvezza",
      "Paludi di Kaw",
    ],
    gastronomy:
      "Brodo di awara, fricassea di selvaggina, pollo arrosto creolo.",
  },
  re: {
    description:
      "Un gioiello vulcanico dell'Oceano Indiano che mescola lagune e cime montuose esotiche.",
    landmarks: ["Piton de la Fournaise", "Circo di Mafate", "Piton des Neiges"],
    gastronomy: "Salsiccia al rougail, pollo al curry, samosa.",
  },
  yt: {
    description:
      "L'isola dei profumi circondata da un'enorme laguna protetta che ospita maestose tartarughe marine.",
    landmarks: ["Laguna di Mayotte", "Monte Choungui", "Spiaggia N'Gouja"],
    gastronomy: "Spiedini di zebù, mataba, riso pilao.",
  },
  pf: {
    description:
      "Il paradiso terrestre del Pacifico, ricco di lussuosi bungalow sull'acqua.",
    landmarks: ["Laguna di Bora Bora", "Monte Otemanu", "Baia di Cook"],
    gastronomy: "Pesce crudo nel latte di cocco, fafaru, dessert poe.",
  },
  nc: {
    description:
      "Terra formidabile dei contrasti, con la più grande laguna chiusa al mondo.",
    landmarks: ["Faro Amédée", "Cuore di Voh", "Baia di Oro"],
    gastronomy: "Bougna tradizionale, insalata di cervo, ceviche.",
  },
  ic: {
    description:
      "Un arcipelago di primavera eterna scolpito dagli affascinanti paesaggi vulcanici.",
    landmarks: ["Parco del Teide", "Dune di Maspalomas", "Parco Timanfaya"],
    gastronomy: "Papas arrugadas, salsa mojo, sancocho.",
  },
  ptm: {
    description:
      "L'isola gettata verticalmente nel blu dell'Atlantico con i suoi stupendi giardini incantati.",
    landmarks: ["Pico do Arieiro", "Cabo Girão", "I sentieri Levadas"],
    gastronomy: "Espetada, pane bolo do caco, pesce sciabola.",
  },
  pta: {
    description:
      "Un santuario preservato dove i crateri formano romantici laghi gemelli.",
    landmarks: ["Laghi Sete Cidades", "Monte Pico", "Sorgenti di Furnas"],
    gastronomy: "Cozido das Furnas, formaggio di São Jorge.",
  },
  aw: {
    description:
      "Una rinfrescante brezza accarezza le eteree spiagge bianche di quest'isola paradisiaca.",
    landmarks: ["Parco Arikok", "Eagle Beach", "Faro California"],
    gastronomy: "Keshi Yena, pastechi fritti, stufato di capra.",
  },
  cw: {
    description:
      "Famosa per le insenature cristalline nascoste e l'architettura pastello colorata.",
    landmarks: ["Ponte Regina Emma", "Playa Porto Mari", "Parco Christoffel"],
    gastronomy: "Karni stoba (stufato di manzo), frittelle di zucca.",
  },
  sx: {
    description:
      "The Friendly Island, accattivante per gli aerei sopra la sua spiaggia e l'eccellente gastronomia locale.",
    landmarks: ["Maho Beach", "Pic Paradis", "Orient Bay"],
    gastronomy: "Costolette BBQ, journey cakes, granchio ripieno.",
  },
  bm: {
    description:
      "Un mitico arcipelago allineato di riviere raffinate e dolci spiagge di sabbia rosa.",
    landmarks: [
      "Horseshoe Bay Beach",
      "Grotte di Cristallo",
      "Faro Gibbs Hill",
    ],
    gastronomy: "Zuppa di pesce al rum di Bermuda, hoppin' john.",
  },
  ky: {
    description:
      "La meta globale per l'immersione che offre fantastici spettacolini dei pesci pastinache.",
    landmarks: ["Stingray City", "Seven Mile Beach", "Parco Botanico"],
    gastronomy: "Manzo stile Cayman, frittelle di conchiglia.",
  },

  fr: {
    description:
      "La Francia è la principale destinazione turistica del mondo, rinomata per il suo eccezionale patrimonio, i diversi paesaggi che vanno dalla Costa Azzurra alle vette alpine e un'incomparabile arte di vivere.",
    gastronomy: "Baguette, formaggi, vino, croissant, bourguignon di manzo.",
    landmarks: [
      "Torre Eiffel, Parigi",
      "Mont Saint-Michel",
      "Castelli della Valle della Loira",
      "Costa Azzurra",
    ],
    overseas: [
      "Guadalupa",
      "Martinica",
      "Guiana francese",
      "Riunione",
      "Mayotte",
      "Polinesia francese",
      "Nuova Caledonia",
    ],
  },
  es: {
    description:
      "La Spagna affascina con il suo clima soleggiato, la sua vivace cultura, dalla siesta al flamenco, le magnifiche spiagge e l'architettura storica unica, in particolare la sua eredità moresca.",
    gastronomy: "Tapas, paella, prosciutto iberico, gazpacho, sangria.",
    landmarks: [
      "Sagrada Familia, Barcellona",
      "Alhambra, Granada",
      "Palazzo Reale di Madrid",
      "Plaza de España, Siviglia",
    ],
    overseas: ["Isole Canarie", "Isole Baleari", "Ceuta", "Melilla"],
  },
  it: {
    description:
      "L’Italia è un museo a cielo aperto. Tra rovine romane, rinascimento fiorentino, canali veneziani e una costa pittoresca, il paese offre un viaggio indimenticabile.",
    gastronomy: "Pasta, pizza, gelato, caffè espresso, tiramisù.",
    landmarks: [
      "Colosseo, Roma",
      "Torre pendente di Pisa",
      "Duomo di Firenze",
      "Canal Grande, Venezia",
    ],
    overseas: ["Sardegna"],
  },
  de: {
    description:
      "La Germania fonde la modernità urbana con il romanticismo dei suoi castelli e della Foresta Nera. Conosciuto per il suo dinamismo e la sua ricca storia.",
    gastronomy: "Bratwurst, pretzel, crauti, birra.",
    landmarks: [
      "Porta di Brandeburgo, Berlino",
      "Castello di Neuschwanstein",
      "Cattedrale di Colonia",
      "Marienplatz, Monaco",
    ],
  },
  gb: {
    description:
      "Il Regno Unito offre un mix unico di tradizione monarchica, avanguardia culturale, splendidi paesaggi scozzesi e città storiche.",
    gastronomy: "Fish and chips, roast beef, Yorkshire pudding, tè.",
    landmarks: [
      "Big Ben e Palazzo di Westminster",
      "Stonehenge",
      "Torre di Londra",
      "Castello di Edimburgo",
    ],
    overseas: ["Bermude", "Isole Cayman", "Gibilterra"],
  },
  pt: {
    description:
      "Il Portogallo incanta con le sue strade colorate, le spiagge bagnate dall'Atlantico e l'eccezionale ospitalità della sua gente, accompagnata dalla inquietante melodia del Fado.",
    gastronomy: "Pastéis de nata, bacalhau, Francesinha, vino di Porto.",
    landmarks: [
      "Torre di Belém, Lisbona",
      "Ribeira, Oporto",
      "Palazzo Pena, Sintra",
      "Spiagge dell'Algarve",
    ],
    overseas: ["Madera", "Azzorre"],
  },
  gr: {
    description:
      "Culla della civiltà occidentale, la Grecia ti invita in un viaggio mitologico, dall'Acropoli alle sublimi acque cristalline delle isole Cicladi.",
    gastronomy: "Moussaka, souvlaki, insalata greca, tzatziki.",
    landmarks: [
      "Acropoli di Atene",
      "Santorini",
      "Meteora",
      "Palazzo di Cnosso",
    ],
    overseas: ["Creta", "Rodi"],
  },
  ch: {
    description:
      "La Svizzera è un paradiso alpino che offre laghi dal blu intenso, fortezze medievali e montagne impressionanti, perfetti sia per gli amanti della natura che del comfort.",
    gastronomy: "Fonduta di formaggio, raclette, cioccolato svizzero, rösti.",
    landmarks: [
      "Cervino",
      "Lago di Ginevra",
      "Castello di Chillon",
      "Jungfraujoch",
    ],
  },
  nl: {
    description:
      "I Paesi Bassi sono famosi per i loro paesaggi pianeggianti, i canali labirintici, i campi di tulipani e gli iconici mulini a vento.",
    gastronomy: "Gouda, stroopwafel, aringa cruda, poffertjes.",
    landmarks: [
      "Canali di Amsterdam",
      "Giardini Keukenhof",
      "Mulini a vento di Kinderdijk",
      "Museo Van Gogh",
    ],
    overseas: ["Aruba", "Curaçao"],
  },
  be: {
    description:
      "Nel cuore dell'Europa, il Belgio è famoso in tutto il mondo per le sue incantevoli città medievali, la diplomazia europea, il cioccolato e la birra.",
    gastronomy: "Cialde, patatine fritte, cozze, praline, birre trappiste.",
    landmarks: [
      "Grande Piazza di Bruxelles",
      "Campanile di Bruges",
      "Atomio",
      "Castello di Gravensteen",
    ],
  },
  bg: {
    description:
      "La Bulgaria è un mosaico balcanico che combina le coste dorate del Mar Nero, i terreni montuosi e un'incredibile eredità della Tracia.",
    gastronomy: "Banitsa, insalata Shopska, tarator, moussaka bulgara.",
    landmarks: [
      "Monastero di Rila",
      "Cattedrale di Aleksandr Nevskij",
      "Spiaggia soleggiata",
    ],
  },
  dk: {
    description:
      "La Danimarca rappresenta il concetto di 'Hygge': un pacifico paese nordico, pioniere nel design, pieno di piste ciclabili e palazzi reali.",
    gastronomy: "Birra Smørrebrød, frikadeller, Wienerbrød, Carlsberg.",
    landmarks: [
      "Giardini di Tivoli",
      "Nyhavn",
      "La Sirenetta",
      "Castello di Kronborg",
    ],
    overseas: ["Isole Faroe", "Groenlandia"],
  },
  hr: {
    description:
      "La Croazia offre oltre mille isole lungo il Mar Adriatico, costellate di gioielli architettonici romani e lussureggianti parchi nazionali.",
    gastronomy: "Ćevapi, insalata di polpo, peka, formaggi dell'isola di Pag.",
    landmarks: [
      "Mura di Dubrovnik",
      "Parco nazionale dei laghi di Plitvice",
      "Palazzo di Diocleziano",
    ],
  },
  cy: {
    description:
      "Cipro è una leggendaria isola del Mediterraneo, luogo di nascita di Afrodite, che unisce spiagge incontaminate con imponenti rovine antiche.",
    gastronomy: "Halloumi, souvla, sheftalia, moussaka.",
    landmarks: [
      "Parco archeologico di Paphos",
      "La Roccia di Afrodite",
      "Monti Troodos",
    ],
  },
  cz: {
    description:
      "La Repubblica Ceca affascina con le sue città dalle cento guglie, i birrifici secolari e i castelli da favola nel cuore dell'Europa centrale.",
    gastronomy: "Goulash, Trdelník, Vepřo knedlo zelo, Pilsner.",
    landmarks: [
      "Ponte Carlo, Praga",
      "Castello di Praga",
      "Ossario di Sedlec",
      "Karlovy Vary",
    ],
  },
  ee: {
    description:
      "L’Estonia è una nazione pioniera del digitale che ospita vaste foreste primordiali e una capitale medievale intatta affacciata sul Baltico.",
    gastronomy:
      "Verivorst (sanguinaccio), pane nero, spratti, birra artigianale.",
    landmarks: [
      "Città vecchia di Tallinn",
      "Parco Nazionale Lahemaa",
      "Castello Hermann",
    ],
  },
  fi: {
    description:
      "La Finlandia, il paese dai mille laghi, è famosa per la sua natura scintillante, l'aurora boreale in Lapponia e la sua vitale cultura della sauna.",
    gastronomy:
      "Salmone affumicato, carne di renna, pane di segale, pasticcini della Carelia.",
    landmarks: [
      "Suomenlinna",
      "Villaggio di Babbo Natale",
      "Parco Nazionale di Nuuksio",
    ],
  },
  hu: {
    description:
      "L'Ungheria è splendidamente divisa in due dal Danubio, ricca di spettacolari bagni termali, vigneti storici e il maestoso parlamento.",
    gastronomy: "Goulash, Lángos, Pollo Paprikash, Vino Tokaji.",
    landmarks: [
      "Parlamento di Budapest",
      "Bagni termali Széchenyi",
      "Castello di Buda",
      "Lago Balaton",
    ],
  },
  ie: {
    description:
      "L'Irlanda, l'Isola di Smeraldo, è caratterizzata dalle sue scogliere battute dal vento, dalla calda musica celtica e dall'accogliente cultura dei pub.",
    gastronomy: "Stufato irlandese, Guinness, soda bread, colcannon.",
    landmarks: [
      "Scogliere di Moher",
      "Deposito della Guinness",
      "Anello di Kerry",
      "Trinity College",
    ],
  },
  lv: {
    description:
      "La Lettonia incanta con la sua vivace capitale ricca di architettura Art Nouveau e chilometri di spiagge incontaminate sulla costa baltica.",
    gastronomy:
      "Rupjmaize (pane scuro di segale), piselli grigi con pancetta, spratti.",
    landmarks: [
      "Città vecchia di Riga",
      "Casa delle Teste Nere",
      "Parco Nazionale Gauja",
    ],
  },
  lt: {
    description:
      "La Lituania è la gemma baltica più meridionale, ricca di laghi glaciali, fitte foreste e toccanti testimonianze del suo tumultuoso passato.",
    gastronomy:
      "Cepelinai (gnocchi di patate), zuppa fredda di borscht (šaltibarščiai).",
    landmarks: [
      "Castello dell'isola di Trakai",
      "Collina delle Croci",
      "Città vecchia di Vilnius",
    ],
  },
  lu: {
    description:
      "Il Lussemburgo è un prospero microstato granducale, le cui valli sono ricche di castelli medievali e la capitale è una spettacolare cittadella.",
    gastronomy:
      "Judd mat Gaardebounen, Gromperekichelcher, vini della Mosella.",
    landmarks: [
      "Cammino della Corniche",
      "Casematte di Bock",
      "Castello di Vianden",
    ],
  },
  mt: {
    description:
      "Malta combina perfettamente il calore del sole del Mediterraneo e 7.000 anni di storia navale, fortezze templari e lagune turchesi.",
    gastronomy: "Pastizzi, coniglio in umido (Stuffat tal-fenek), ftira.",
    landmarks: [
      "Concattedrale di San Giovanni",
      "Città di Medina",
      "Laguna Blu (Comino)",
    ],
  },
  pl: {
    description:
      "La Polonia è il pilastro culturale dell'Europa orientale, dotata di imponenti città restaurate, del tragico memoriale di Auschwitz e dei monti Tatra.",
    gastronomy: "Pierogi, bigos, kielbasa, vodka polacca.",
    landmarks: [
      "Piazza del mercato di Cracovia",
      "Miniera di sale di Wieliczka",
      "Auschwitz-Birkenau",
      "Castello di Wawel",
    ],
  },
  ro: {
    description:
      "Dominata dalla leggenda di Dracula, la Romania ospita i sontuosi Monti Carpazi, il maestoso delta del Danubio e le vivaci città della Transilvania.",
    gastronomy: "Mici, sarmale, mămăligă, tuică.",
    landmarks: [
      "Castello di Bran",
      "Castello di Peles",
      "Delta del Danubio",
      "Palazzo del Parlamento",
    ],
  },
  sk: {
    description:
      "Meno conosciuta, la Slovacchia è un tesoro montuoso con il maggior numero di castelli pro capite al mondo, all'interno degli Alti Tatra.",
    gastronomy: "Bryndzové halušky (gnocchi di formaggio di pecora), Kofola.",
    landmarks: ["Castello di Bratislava", "Alti Tatra", "Castello di Spiš"],
  },
  si: {
    description:
      "La Slovenia è un piccolo eco-paradiso che ospita il mitico Lago di Bled, colossali grotte carsiche e una capitale eccezionalmente verde.",
    gastronomy: "Kranjska klobasa, potica (rotolo di noci), štrukli.",
    landmarks: [
      "Lago di Bled",
      "Grotte di Postumia",
      "Castello di Lubiana",
      "Parco nazionale del Triglav",
    ],
  },
  se: {
    description:
      "La Svezia incarna lo stile scandinavo, diffuso tra magnifici arcipelaghi, aurore boreali e una ricca tradizione di design elegante.",
    gastronomy:
      "Polpette (Köttbullar), fika, salmone gravlax, aringhe surströmming.",
    landmarks: [
      "Museo Vasa",
      "Città di Visby",
      "Gamla Stan",
      "Icehotel Jukkasjärvi",
    ],
  },
  is: {
    description:
      "L'Islanda, la terra del fuoco e del ghiaccio, colpisce con stupore con i suoi geyser, i ghiacciai titanici, i vulcani attivi e le sorgenti termali lattiginose.",
    gastronomy: "Hákarl (squalo fermentato), Skyr, agnello islandese.",
    landmarks: [
      "Laguna Blu",
      "Cerchio d'Oro",
      "Cascata Gullfoss",
      "Spiaggia di sabbia nera di Reynisfjara",
    ],
  },
  no: {
    description:
      "La Norvegia offre uno degli scenari geologici più belli del mondo: i suoi maestosi fiordi abissali che scolpiscono il mare circondati da ripide montagne.",
    gastronomy: "Salmone, rakfisk, formaggio marrone (Brunost), carne di alce.",
    landmarks: ["Fiordo di Geiranger", "Capo Nord", "Isole Lofoten", "Bryggen"],
  },
  al: {
    description:
      "Precedentemente ermetica, l'Albania è la gemma segreta del Mediterraneo, ricca di acque blu cristalline, spettacolari Alpi e rovine greco-romane.",
    gastronomy: "Byrek, fëgesë, frutti di mare, baklava.",
    landmarks: ["Riviera albanese", "Berat", "Parco Nazionale di Butrinto"],
  },
  ad: {
    description:
      "Incastonato tra i Pirenei, questo piccolo principato è un vero santuario per gli amanti dello sci e della natura selvaggia.",
    gastronomy: "Trinxat, escudella, salumi di montagna.",
    landmarks: ["Valle Madriu-Perafita-Claror", "Caldea", "Grandvalira"],
  },
  at: {
    description:
      "Paese alpino per eccellenza, l'Austria brilla con la sua musica classica senza pari, i palazzi imperiali e i paesaggi alpini mozzafiato.",
    gastronomy: "Wiener Schnitzel, Apfelstrudel, Sachertorte, Tafelspitz.",
    landmarks: ["Palazzo di Schönbrunn", "Hofburg", "Alpi di Kitzbühel"],
  },
  mc: {
    description:
      "Monaco è l'epitome del glamour sulle rive del Mediterraneo, con yacht di lusso, il suo casinò di fama mondiale e il leggendario Gran Premio di Formula 1.",
    gastronomy: "Barbajuan, fougasse monegasca, stocafi.",
    landmarks: [
      "Casinò di Monte Carlo",
      "La Rocca di Monaco",
      "Palazzo del Principe",
      "Porto Ercole",
    ],
  },
  am: {
    description:
      "L'Armenia, una delle nazioni cristiane più antiche del mondo, offre spettacolari paesaggi montuosi e maestosi monasteri di pietra arroccati sul bordo di profondi canyon.",
    gastronomy: "Khorovats (barbecue armeno), dolma, lavash, lahmajoun.",
    landmarks: [
      "Monastero di Khor Virap",
      "Tempio di Garni",
      "Monastero di Gegard",
    ],
  },
  az: {
    description:
      "L'Azerbaigian, la \"Terra del Fuoco\", è un'affascinante miscela di antico patrimonio storico e scintillanti infrastrutture ultramoderne sulle rive del Mar Caspio.",
    gastronomy: "Plov, dolma, piti, qutab, baklava.",
    landmarks: [
      "Torri di fiamma (Baku)",
      "Città Vecchia (Icherisheher)",
      "Vulcani di fango di Gobustan",
    ],
  },
  by: {
    description:
      "La Bielorussia sorprende con la sua natura preservata, fitte foreste incontaminate (come Bialowieza) che ospitano bisonti e castelli medievali dal ricco passato.",
    gastronomy: "Draniki (frittelle di patate), machanka, kolduny.",
    landmarks: ["Castello di Mir", "Palazzo Nesvizh", "Fortezza di Brest"],
  },
  ba: {
    description:
      "Un crocevia di culture nel cuore dei Balcani dove l'Oriente incontra l'Occidente. Ti innamorerai dei fiumi color smeraldo, delle aspre montagne e del famoso Ponte Vecchio di Mostar.",
    gastronomy: "Ćevapi, burek, baklava, caffè bosniaco.",
    landmarks: [
      "Stari Most (Ponte Vecchio)",
      "Baščaršija (Sarajevo)",
      "Cascate di Kravica",
    ],
  },
  ge: {
    description:
      "La Georgia offre una natura grandiosa nelle montagne del Caucaso, un'affascinante architettura antica e la reputazione di essere la regione vinicola più antica del mondo.",
    gastronomy: "Khachapuri, khinkali (ravioli), churchkhela.",
    landmarks: [
      "Chiesa della Trinità di Gergeti",
      "Città vecchia di Tbilisi",
      "Vardzia (Città delle Grotte)",
    ],
  },
  xk: {
    description:
      "Giovane nazione balcanica, ricca di storia e di splendidi paesaggi montuosi, il Kosovo si distingue per i gioielli storici ottomani ben conservati e una popolazione molto accogliente.",
    gastronomy: "Flija, burek, qebapa, formaggio Šar.",
    landmarks: [
      "Monastero di Visoki Dečani",
      "Il vecchio Prizren",
      "Canyon Rugova",
    ],
  },
  li: {
    description:
      "Una delle nazioni più piccole del mondo, il Liechtenstein si estende tra Svizzera e Austria lungo la valle del Reno, dominata dal suo bellissimo castello principesco e dalle vette alpine.",
    gastronomy: "Käsknöpfle (pasta al formaggio), Ribel.",
    landmarks: [
      "Castello di Vaduz",
      "Museo delle Belle Arti (Kunstmuseum)",
      "Stazione sciistica di Malbun",
    ],
  },
  md: {
    description:
      "La Moldavia, il tesoro nascosto dell'Europa orientale, attira inevitabilmente gli appassionati di enoturismo con le sue enormi cantine sotterranee e gli ancestrali monasteri scavati nella roccia.",
    gastronomy: "Mămăligă (polenta), plăcinte (pasticcini ripieni), sarmale.",
    landmarks: [
      "Orheiul Vechi (Monastero rupestre)",
      "Cantine Cricova",
      "Cantine Mileștii Mici",
    ],
  },
  me: {
    description:
      'Nonostante le sue piccole dimensioni, il Montenegro nasconde alcuni dei paesaggi più belli del Mar Adriatico. La baia di Kotor incontra spettacolari montagne scure (le "montagne nere").',
    gastronomy:
      "Brav u Mlijeku (agnello al latte), cevapi, prosciutto affumicato di Njeguši.",
    landmarks: [
      "Bocche di Cattaro",
      "Parco Nazionale del Durmitor",
      "Santo Stefano",
    ],
  },
  mk: {
    description:
      "Nel cuore dei Balcani, la Macedonia del Nord abbaglia con l'incredibilmente limpido e antico lago di Ocrida, la sua eredità ortodossa e i parchi nazionali preservati.",
    gastronomy: "Tavče gravče (fagioli al forno), ajvar, pastrmajlija.",
    landmarks: [
      "Lago di Ocrida",
      "Chiesa di San Giovanni a Kaneo",
      "Canyon di Matka",
    ],
  },
  sm: {
    description:
      "Arroccato sul Monte Titano e completamente senza sbocco sul mare dall'Italia, San Marino rivendica il titolo di repubblica più antica del mondo e stato costituzionale sovrano.",
    gastronomy: "Torta Tre Monti, piadina, fagioli con cotiche.",
    landmarks: [
      "Le Tre Torri (Guaita, Cesta, Montale)",
      "Basilica di San Marino",
      "Piazza della Libertà",
    ],
  },
  rs: {
    description:
      "La Serbia combina la vivace vita notturna di Belgrado sul Danubio, la spettacolare fortezza di Petrovaradin e gli splendidi monasteri ortodossi nascosti.",
    gastronomy: "Cevapi, pljeskavica, kajmak, rakija (acquavite di frutta).",
    landmarks: [
      "Fortezza di Belgrado (Kalemegdan)",
      "Fortezza di Golubac",
      "Tempio di San Sava",
    ],
  },
  va: {
    description:
      "Il Vaticano, lo stato sovrano più piccolo del mondo, risiede nel cuore di Roma e funge da sede spirituale della Chiesa cattolica e ospita prodigiosi capolavori artistici di Michelangelo.",
    gastronomy:
      "Nessuna cucina esclusiva; presenta la tradizionale gastronomia romana.",
    landmarks: ["Basilica di San Pietro", "Cappella Sistina", "Musei Vaticani"],
  },
};
